import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { $post } from './store/api';

function ForgotPassword({ onBack }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await $post('auth/forgot-password', { Email: email });
      setSent(true);
    } catch {
      setError('Hiba történt. Kérjük, próbáld újra.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <div className="auth-logo">
          <img
            src="https://www.presentperfect.xyz/wp-content/uploads/2018/11/pp_logo_head_mobile.png"
            alt="Present Perfect"
          />
        </div>
        <h2 className="auth-title">Jelszó visszaállítás</h2>
        {sent ? (
          <>
            <Alert variant="success" style={{ fontSize: 14 }}>
              Ha a megadott e-mail cím regisztrált, hamarosan megérkezik a visszaállítási link.
            </Alert>
            <Button variant="secondary" className="w-100" onClick={onBack}>
              Vissza a bejelentkezéshez
            </Button>
          </>
        ) : (
          <>
            {error && <Alert variant="danger" className="py-2 px-3" style={{ fontSize: 14 }}>{error}</Alert>}
            <p className="text-muted mb-3" style={{ fontSize: 14 }}>
              Add meg az e-mail címedet és küldünk egy jelszó-visszaállítási linket.
            </p>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <Form.Label>E-mail cím</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="pelda@email.com"
                  required
                  autoFocus
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="w-100 mb-2" disabled={loading}>
                {loading ? 'Küldés…' : 'Visszaállítási link küldése'}
              </Button>
              <Button variant="link" className="w-100 text-muted" style={{ fontSize: 14 }} onClick={onBack}>
                Vissza
              </Button>
            </Form>
          </>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
